export class DatabaseConnectionTestRequest {
  tokenResulthLocalConnect: string;
  hostBD: string;
  portaBD: number;
  caminhoBD: string;
  usuarioBD: string;
  senhaBD: string;
}
